import React from 'react'
import { ContactChip } from '@fs/zion-contact-overlay'
import { familySearchCisId } from '../../../../shared/services/config'

export default function User({ userId, fallBackToFs = false }) {
  if (userId?.startsWith('fs:') || userId?.startsWith('cis.proc.') || (!userId && fallBackToFs)) {
    userId = familySearchCisId
  }
  return <ContactChip contact={{ cisId: userId }} />
}
